import { render, staticRenderFns } from "./reexaminationApplication.vue?vue&type=template&id=60ad8893&scoped=true"
import script from "./reexaminationApplication.vue?vue&type=script&lang=js"
export * from "./reexaminationApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad8893",
  null
  
)

export default component.exports